interface OpenReplayQueue extends Array<unknown> {
  start: () => void;
  stop: () => void;
  setUserID: (id: string) => void;
  setUserAnonymousID: (id: string) => void;
  setMetadata: (key: string, value: unknown) => void;
  event: (key: string, payload: unknown, issue?: unknown) => void;
  issue: (key: string, payload: unknown) => void;
  isActive: () => boolean;
  getSessionToken: () => undefined;
}

declare global {
  interface Window {
    OpenReplay?: OpenReplayQueue;
  }
}

export function initializeOpenReplay(
  projectKey = process.env.REACT_APP_OPENREPLAY_PROJECT_KEY ?? ""
): void {
  if (!projectKey || window.OpenReplay) {
    return;
  }

  const initOptions = {
    projectKey,
    defaultInputMode: 2,
    obscureTextNumbers: true,
    obscureTextEmails: true,
  };
  const startOptions = { userID: "" };
  const queue = [
    startOptions,
    undefined,
    initOptions,
    [0, startOptions],
  ] as unknown as OpenReplayQueue;

  queue.start = (): void => {
    queue.push([0]);
  };
  queue.stop = (): void => {
    queue.push([1]);
  };
  queue.setUserID = (id): void => {
    queue.push([2, id]);
  };
  queue.setUserAnonymousID = (id): void => {
    queue.push([3, id]);
  };
  queue.setMetadata = (key, value): void => {
    queue.push([4, key, value]);
  };
  queue.event = (key, payload, issue): void => {
    queue.push([5, key, payload, issue]);
  };
  queue.issue = (key, payload): void => {
    queue.push([6, key, payload]);
  };
  queue.isActive = (): boolean => false;
  queue.getSessionToken = (): undefined => undefined;
  window.OpenReplay = queue;

  const script = document.createElement("script");
  // The vendor CDN does not return ACAO, so cross-origin SRI would block the script.
  script.src = "https://static.openreplay.com/18.1.2/openreplay.js";
  script.async = true;
  document.head.appendChild(script);
}
